import { render, staticRenderFns } from "./CNotices.vue?vue&type=template&id=1af56409"
import script from "./CNotices.vue?vue&type=script&lang=js"
export * from "./CNotices.vue?vue&type=script&lang=js"
import style0 from "./CNotices.vue?vue&type=style&index=0&id=1af56409&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports